import React from 'react';
import { CardGroup } from 'shared-components';
import SystemStatusDashboard from './Dashboard';

function SystemStatus() {
  return (
    <CardGroup>
      <SystemStatusDashboard />
    </CardGroup>
  );
}

export default SystemStatus;
